<section class="row clearfix p-h-md top_function" id="top_function">
  <div class="col-lg-12">
    <div class="search_02">
      <div class="row m-n">
        <div class="bar">
          <label for="searchSubject" class="sr-only">{{'searchpage.subject' | translate}}</label>
          <select id="searchSubject" name="searchSubject" [(ngModel)]="searchSubject">
            <option [ngValue]="undefined">{{'searchpage.allSubject' | translate}}</option>
            <ng-container *ngFor="let opt of SUBJECT_OPTIONS; index as i">
              <option [ngValue]="opt">{{opt.label}}</option>
            </ng-container>
          </select>

          <div class="selectbar" style="pointer-events: none; user-select: none;" aria-hidden="true">｜</div>

          <div class="searchbar">
            <label for="searchKeyword" class="sr-only">{{'keyword' | translate}}</label>
            <input id="searchKeyword" type="text" placeholder="{{'searchpage.searchPlaceholder2' | translate}}"
            name="searchKeyword" [(ngModel)]="searchKeyword" (ngModelChange)="onKeywordChange($event)"
            (focus)="onFocusSearchKeywordInput()" #searchKeywordInput>
            <tm-auto-complete-options #skACO="tmAutoCompleteOptions"
            [options]="keywordsOptions"
            [togglerEl]="searchKeywordInput"
            id="dataSearchKeywordOptions"
            label="{{'keywordAutoCompleteOptions' | translate}}"
            (selected)="searchKeyword = $event; onKeywordChange($event); onClickSearch();"
            ></tm-auto-complete-options>
          </div>

          <a href="javascript:void(0)" role="button" title="{{'search' | translate}}" class="searchtool"
          (click)="onClickSearch($event)">
            <i class="fa fa-search" aria-hidden="true"></i>
            <span class="sr-only">{{'search' | translate}}</span>
          </a>
        </div>
      </div>

      <div class="row m-n">
        <div class="tools">
          <label for="format" (click)="formatFilterList.focus()" class="sr-only">{{'searchpage.dataFormat' | translate}}</label>
          <ul id="format" attr.aria-label="{{ 'filterBy' | translate: ({filter: ('searchpage.dataFormat' | translate)}) }}" role="listbox" tabindex="-1" #formatFilterList>
            <a href="javascript: void(0)" title="{{'all' | translate}}"
              role="option" [class.active]="!searchFilter.format"
              aria-disabled="false" [attr.aria-selected]="!searchFilter.format"
              (click)="selectFormatAll()"><li><span class="tools001">{{'all' | translate}}</span></li></a>
            <ng-container *ngFor="let opt of FORMAT_OPTIONS; index as i">
              <ng-container *ngIf="opt.label !== '文件' && opt.label !== '其他'">
                <a href="javascript: void(0)" title="{{opt.label}}"
                  role="option" [class.active]="searchFilter.format === opt"
                  aria-disabled="false" [attr.aria-selected]="searchFilter.format === opt"
                  (click)="selectFormat(opt)"><li><span class="tools00{{i + 2}}">{{opt.label}}</span></li></a>
              </ng-container>
            </ng-container>
          </ul>
        </div>
      </div>

      <div class="iamhr"></div>

      <div class="row">
        <div class="col-sm-12 col-md-3">
          <h3>{{'searchpage.searchResult' | translate}}<span class="num" *ngIf="searchResult">{{total | tmCurrency}}</span><span style="word-break: keep-all;">{{'searchpage.numsData' | translate}}</span></h3>
        </div>

        <div class="col-sm-12 col-md-9 condition" *ngIf="hasAnySearchFilter">
          <label for="filterCondition" (click)="filterConditionList.focus()">{{'searchpage.filterCondition' | translate}}</label>
          <ul id="filterCondition" role="listbox" tabindex="-1" #filterConditionList>
            <ng-container *ngFor="let sk of showedFilterConditionKeys">
              <li class="condition_tap" tabindex="0" *ngIf="(sk !== 'subject' && searchFilter[sk]) || (sk === 'subject' && query.subject)">
                <span>{{('searchpage.showedFilterConditionLabel.' + sk) | translate}}：</span>
                <span [ngSwitch]="sk">
                  <ng-container *ngSwitchCase="'subject'">{{query.subject.label}}</ng-container>
                  <ng-container *ngSwitchCase="'format'">{{searchFilter[sk].label}}</ng-container>
                  <ng-container *ngSwitchDefault>{{searchFilter[sk] | map2Label}}</ng-container>
                </span>
                <a href="javascript: void(0)" title="{{('searchpage.showedFilterConditionLabel.' + sk) | translate}}｜{{'clear' | translate}}"
                role="option"
                aria-disabled="false" aria-selected="true"
                (click)="removeCondition(sk)">
                  <i class="fa fa-times" aria-hidden="true"></i>
                  <span class="sr-only">{{'clear' | translate}}{{('searchpage.showedFilterConditionLabel.' + sk) | translate}}</span>
                </a>
              </li>
            </ng-container>
          </ul>

          <a class="condition_tap" href="javascript: void(0)" role="button" attr.aria-label="{{'searchpage.clearAllFilterCondition' | translate}}" (click)="removeAllCondition()">{{'clear' | translate}}{{'all' | translate}}
            <i class="fa fa-trash-o" aria-hidden="true"></i>
          </a>
        </div>
      </div>

      <div class="row m-n">
        <div class="filterbar">
          <ul>
            <li class="dropdown" appBsDropdownStatus #fetchIndexDpStatus="bsDpStatus">
              <a href="javascript:void(0)" role="button" class="dropdown-toggle" id="fetchIndexDPToggler"
              data-toggle="dropdown" aria-expanded="false"><span>{{'searchpage.showedFilterConditionLabel.fetchIndex' | translate}}</span>
                <i class="fa fa-angle-down" aria-hidden="true" *ngIf="!fetchIndexDpStatus.isOpen"></i>
                <i class="fa fa-angle-up" aria-hidden="true" *ngIf="fetchIndexDpStatus.isOpen"></i>
              </a>
              <div class="open_menuLG dropdown-menu" aria-labelledby="fetchIndexDPToggler">
                <form method="POST" action="" *ngIf="FETCH_INDEX_OPTIONS">
                  <dd class="dl-horizontal-dd">
                    <ul>
                      <a href="javascript: void(0)" class="active" role="button" (click)="selectFetchIndexAll()"
                      [class.active]="searchFilter.fetchIndex | matchAnotherArray: FETCH_INDEX_OPTIONS">
                      <!-- <li>{{(searchFilter.fetchIndex | matchAnotherArray: FETCH_INDEX_OPTIONS) ? ('cancelSelectAll' | translate) : ('all' | translate)}}</li> -->
                      <li>{{'all' | translate}}</li>
                    </a>
                    </ul>
                  </dd>

                  <div class="iamhr"></div>

                  <label for="fetchIndex" (click)="fetchIndexFilterList.focus()" class="sr-only">{{'searchpage.showedFilterConditionLabel.fetchIndex' | translate}}{{'options' | translate}}</label>
                  <ul id="fetchIndex" attr.aria-label="{{ 'filterBy' | translate: ({filter: ('searchpage.showedFilterConditionLabel.fetchIndex' | translate) + ('options' | translate)}) }}" role="listbox" tabindex="-1" #fetchIndexFilterList>
                    <ng-container *ngFor="let opt of FETCH_INDEX_OPTIONS">
                      <li class="menuLG">
                        <input type="checkbox" value="{{opt.id}}" class="checkbox" id="fetchIndex_{{opt.id}}"
                        name="fetchIndex_{{opt.id}}" [ngModel]="(searchFilter.fetchIndex ? (searchFilter.fetchIndex | isInArray: opt) : searchFilter.fetchIndex)"
                        (ngModelChange)="checkFetchIndex(opt, $event)">
                        <label for="fetchIndex_{{opt.id}}"><span>{{opt.label}}</span></label>
                        <span class="snum">{{keyword ? opt.itri_doc_count : opt.doc_count}}</span>
                      </li>
                    </ng-container>
                  </ul>
                  
                  <!-- <div class="d-flex justify-content-end"><button type="button" class="yellow_btn" data-toggle="dropdown" aria-expanded="false">確認</button></div> -->
                </form>
              </div>
            </li>

            <li class="dropdown" appBsDropdownStatus #rightDpStatus="bsDpStatus">
              <a href="javascript:void(0)" role="button" class="dropdown-toggle" id="rightToggler"
              data-toggle="dropdown" aria-expanded="false" [class.disabled]="!RIGHTS_OPTIONS"><span>{{'searchpage.imageRight' | translate}}</span>
                <i class="fa fa-angle-down" aria-hidden="true" *ngIf="!rightDpStatus.isOpen"></i>
                <i class="fa fa-angle-up" aria-hidden="true" *ngIf="rightDpStatus.isOpen"></i>
              </a>
              <div class="open_menuXLG dropdown-menu" aria-labelledby="rightToggler">
                <form method="POST" action="" *ngIf="RIGHTS_OPTIONS">
                  <dd class="dl-horizontal-dd">
                    <label for="rightsGroup" (click)="rightsGroupFilterList.focus()" class="sr-only">{{'searchpage.imageRight' | translate}}{{'quickPick' | translate}}</label>
                    <ul id="rightsGroup" attr.aria-label="{{ 'filterBy' | translate: ({filter: ('searchpage.imageRight' | translate) + ('quickPick' | translate)}) }}" role="listbox" tabindex="-1" #rightsGroupFilterList>
                      <li>
                        <a href="javascript: void(0)" [class.active]="searchFilter.rights | matchAnotherArray: RIGHTS_OPTIONS" role="button" (click)="selectRightsAll()">{{'all' | translate}}</a>
                      </li>
                      <li>
                        <a href="javascript: void(0)" role="option" [class.active]="searchFilter.rights | matchAnotherArray: OPENED_RIGHTS"
                        aria-disabled="false" [attr.aria-selected]="searchFilter.rights | matchAnotherArray: OPENED_RIGHTS"
                        (click)="checkRights('rights', OPENED_RIGHTS)"><label for="opened_rights" (click)="openedRightsFilterList.focus()">{{'searchpage.openedRight' | translate}}</label></a>

                        <ul id="opened_rights" attr.aria-label="{{ 'filterBy' | translate: ({filter: ('searchpage.openedRight' | translate) + ('searchpage.imageRight' | translate) + ('options' | translate)}) }}" role="listbox" tabindex="-1" #openedRightsFilterList>
                          <ng-container *ngFor="let opt of OPENED_RIGHTS">
                            <li class="menuLG">
                              <input type="checkbox" value="{{opt.id}}" class="checkbox" id="opened_rights_{{opt.id}}"
                              name="opened_rights_{{opt.id}}" [ngModel]="(searchFilter.rights ? (searchFilter.rights | isInArray: opt) : searchFilter.rights)"
                              (ngModelChange)="checkRights('rights', opt, $event)">
                              <label for="opened_rights_{{opt.id}}"><span>{{opt.label}}</span></label>
                              <span class="snum">{{keyword ? opt.itri_doc_count : opt.doc_count}}</span>
                            </li>
                          </ng-container>
                        </ul>
                      </li>
                      <li>
                        <a href="javascript: void(0)" role="option" [class.active]="searchFilter.rights | matchAnotherArray: SHARED_RIGHTS"
                        aria-disabled="false" [attr.aria-selected]="searchFilter.rights | matchAnotherArray: SHARED_RIGHTS"
                        (click)="checkRights('rights', SHARED_RIGHTS)"><label for="shared_rights" (click)="sharedRightsFilterList.focus()">{{'searchpage.sharedRight' | translate}}</label></a>

                        <ul id="shared_rights" attr.aria-label="{{ 'filterBy' | translate: ({filter: ('searchpage.sharedRight' | translate) + ('searchpage.imageRight' | translate) + ('options' | translate)}) }}" role="listbox" tabindex="-1" #sharedRightsFilterList>
                          <ng-container *ngFor="let opt of SHARED_RIGHTS">
                            <li class="menuLG">
                              <input type="checkbox" value="{{opt.id}}" class="checkbox" id="shared_rights_{{opt.id}}"
                              name="shared_rights_{{opt.id}}" [ngModel]="(searchFilter.rights ? (searchFilter.rights | isInArray: opt) : searchFilter.rights)"
                              (ngModelChange)="checkRights('rights', opt, $event)">
                              <label for="shared_rights_{{opt.id}}"><span>{{opt.label}}</span></label>
                              <span class="snum">{{keyword ? opt.itri_doc_count : opt.doc_count}}</span>
                            </li>
                          </ng-container>
                        </ul>
                      </li>
                      <li>
                        <a href="javascript: void(0)" role="option" [class.active]="searchFilter.rights | matchAnotherArray: CLOSED_RIGHTS"
                        aria-disabled="false" [attr.aria-selected]="searchFilter.rights | matchAnotherArray: CLOSED_RIGHTS"
                        (click)="checkRights('rights', CLOSED_RIGHTS)"><label for="closed_rights" (click)="closedRightsFilterList.focus()">{{'searchpage.closedRight' | translate}}</label></a>

                        <ul id="closed_rights" attr.aria-label="{{ 'filterBy' | translate: ({filter: ('searchpage.closedRight' | translate) + ('searchpage.imageRight' | translate) + ('options' | translate)}) }}" role="listbox" tabindex="-1" #closedRightsFilterList>
                          <ng-container *ngFor="let opt of CLOSED_RIGHTS">
                            <li class="menuLG">
                              <input type="checkbox" value="{{opt.id}}" class="checkbox" id="closed_rights_{{opt.id}}"
                              name="closed_rights_{{opt.id}}" [ngModel]="(searchFilter.rights ? (searchFilter.rights | isInArray: opt) : searchFilter.rights)"
                              (ngModelChange)="checkRights('rights', opt, $event)">
                              <label for="closed_rights_{{opt.id}}"><span>{{opt.label}}</span></label>
                              <span class="snum">{{keyword ? opt.itri_doc_count : opt.doc_count}}</span>
                            </li>
                          </ng-container>
                        </ul>
                      </li>
                    </ul>
                  </dd>
                  <!-- <div class="d-flex justify-content-end"><button type="button" class="yellow_btn" data-toggle="dropdown" aria-expanded="false">確認</button></div> -->
                </form>
              </div>
            </li>

            <li class="dropdown" appBsDropdownStatus #desRightDpStatus="bsDpStatus">
              <a href="javascript:void(0)" role="button" class="dropdown-toggle" id="desRightDPToggler"
              data-toggle="dropdown" aria-expanded="false" [class.disabled]="!DES_RIGHTS_OPTIONS"><span>{{'searchpage.textRight' | translate}}</span>
                <i class="fa fa-angle-down" aria-hidden="true" *ngIf="!desRightDpStatus.isOpen"></i>
                <i class="fa fa-angle-up" aria-hidden="true" *ngIf="desRightDpStatus.isOpen"></i>
              </a>
              <div class="open_menuSM dropdown-menu" aria-labelledby="desRightDPToggler">
                <form method="POST" action="" *ngIf="DES_RIGHTS_OPTIONS">
                  <label for="desRights" (click)="desRightsFilterList.focus()" class="sr-only">{{'searchpage.textRight' | translate}}{{'options' | translate}}</label>
                  <ul id="desRights" attr.aria-label="{{ 'filterBy' | translate: ({filter: ('searchpage.textRight' | translate) + ('options' | translate)}) }}" role="listbox" tabindex="-1" #desRightsFilterList>
                    <li class="menuSM">
                      <input type="checkbox" value="" class="checkbox" id="desRights_all"
                      [checked]="searchFilter.desRights | matchAnotherArray: DES_RIGHTS_OPTIONS"
                      (change)="selectDesRightsAll($event.target.checked)">
                      <label for="desRights_all"><span>{{'all' | translate}}</span></label>
                      <span class="snum"></span>
                    </li>

                    <ng-container *ngFor="let opt of DES_RIGHTS_OPTIONS">
                      <li class="menuSM">
                        <input type="checkbox" value="{{opt.id}}" class="checkbox" id="desRights_{{opt.id}}"
                        name="desRights_{{opt.id}}" [ngModel]="(searchFilter.desRights ? (searchFilter.desRights | isInArray: opt) : searchFilter.desRights)"
                        (ngModelChange)="checkRights('desRights', opt, $event)">
                        <label for="desRights_{{opt.id}}"><span>{{opt.label}}</span></label>
                        <span class="snum">{{keyword ? opt.itri_doc_count : opt.doc_count}}</span>
                      </li>
                    </ng-container>
                  </ul>
  
                  <!-- <div class="d-flex justify-content-end"><button type="button" class="yellow_btn" data-toggle="dropdown" aria-expanded="false">確認</button></div> -->
                </form>
              </div>
            </li>

            <li class="dropdown" appBsDropdownStatus #distDpStatus="bsDpStatus">
              <a href="javascript:void(0)" role="button" class="dropdown-toggle" id="desRightDPToggler"
              data-toggle="dropdown" aria-expanded="false" [class.disabled]="!CITY_OPTIONS"><span>{{'searchpage.cityAndDist' | translate}}</span>
                <i class="fa fa-angle-down" aria-hidden="true" *ngIf="!distDpStatus.isOpen"></i>
                <i class="fa fa-angle-up" aria-hidden="true" *ngIf="distDpStatus.isOpen"></i>
              </a>
              <div class="open_menuSM dropdown-menu" aria-labelledby="desRightDPToggler">
                <form method="POST" action="" *ngIf="CITY_OPTIONS">
                  <div class="form-group">
                    <label for="city" class="sr-only">{{'city' | translate}}</label>
                    <select id="city" class="form-control" name="city" [(ngModel)]="searchFilter.city" (ngModelChange)="onCityChanged($event)">
                      <option [ngValue]="undefined">{{'selectCity' | translate}}</option>
                      <ng-container *ngFor="let opt of CITY_OPTIONS">
                        <option [ngValue]="opt">{{opt.label}}</option>
                      </ng-container>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="dist" class="sr-only">{{'dist' | translate}}</label>
                    <select id="dist" class="form-control" [disabled]="!searchFilter.city || !DIST_OPTIONS || !DIST_OPTIONS.length"
                    name="dist" [(ngModel)]="searchFilter.dist" (ngModelChange)="onDistChanged($event)">
                      <option [ngValue]="undefined">{{'selectDist' | translate}}</option>
                      <ng-container *ngFor="let opt of DIST_OPTIONS">
                        <option [ngValue]="opt">{{opt.label}}</option>
                      </ng-container>
                    </select>
                  </div>
                  <!-- <div class="d-flex justify-content-end"><button type="button" class="yellow_btn" data-toggle="dropdown" aria-expanded="false">確認</button></div> -->
                </form>
              </div>
            </li>

            <li class="dropdown" appBsDropdownStatus #dateRangeDpStatus="bsDpStatus">
              <a href="javascript:void(0)" role="button" class="dropdown-toggle" id="dateRangeDPToggler"
              data-toggle="dropdown" aria-expanded="false"><span>{{'searchpage.dateRange' | translate}}</span>
                <i class="fa fa-angle-down" aria-hidden="true" *ngIf="!dateRangeDpStatus.isOpen"></i>
                <i class="fa fa-angle-up" aria-hidden="true" *ngIf="dateRangeDpStatus.isOpen"></i>
              </a>
              <div class="open_menuSM dropdown-menu" aria-labelledby="dateRangeDPToggler">
                <form method="POST" action="">
                  <div class="form-group">
                    <label for="startYear" class="sr-only">{{'searchpage.dateRange' | translate}}({{'startYear' | translate}})</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">{{'start' | translate}}</span>
                      </div>
                      <input type="text" class="form-control" id="startYear" placeholder="{{'inputYear' | translate}}"
                      name="startYear" [(ngModel)]="searchFilter.startYear" (ngModelChange)="onStartYearChange($event)"
                      (input)="onInputYear($event, 'start')"
                      (blur)="onStartYearBlur()"
                      (keydown.enter)="onStartYearBlur()"/>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="endYear" class="sr-only">{{'searchpage.dateRange' | translate}}({{'endYear' | translate}})</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">{{'end' | translate}}</span>
                      </div>
                      <input type="text" class="form-control" id="endYear" placeholder="{{'inputYear' | translate}}"
                      [disabled]="!searchFilter.startYear"
                      name="endYear" [(ngModel)]="searchFilter.endYear" (ngModelChange)="onEndYearChange($event)"
                      (input)="onInputYear($event, 'end')"
                      (blur)="onEndYearBlur()"
                      (keydown.enter)="onEndYearBlur()"/>
                    </div>
                  </div>
                  <!-- <div class="d-flex justify-content-end"><button type="button" class="yellow_btn" data-toggle="dropdown" aria-expanded="false">確認</button></div> -->
                </form>
              </div>
            </li>

            <li class="text-filter">
              <div style="position: relative;">
                <label for="createDept" class="sr-only">{{'searchpage.createDept' | translate}}</label>
                <input class="texttype" type="text" placeholder="{{'searchpage.inputCreateDept' | translate}}" name="createDept" id="createDept"
                [ngModel]="searchFilter.createDept" (ngModelChange)="onCreateDeptChange($event)"
                (focus)="createDeptACO.isShowOptions = true;"
                (blur)="changeFilter('createDept', createDeptInput.value)"
                #createDeptInput>
                <tm-auto-complete-options #createDeptACO="tmAutoCompleteOptions"
                [options]="createDeptOptions"
                [togglerEl]="createDeptInput"
                id="dataSearchCreateDeptOptions"
                label="{{'searchpage.createDeptAutoCompleteOptions' | translate}}"
                (selected)="changeFilter('createDept', $event); onCreateDeptChange($event)"
                ></tm-auto-complete-options>
              </div>
            </li>

            <li class="text-filter">
              <label for="negKeyword" class="sr-only">{{'searchpage.excludeKeyword' | translate}}</label>
              <input class="texttype" type="text" placeholder="{{'searchpage.inputExcludeKeyword' | translate}}" name="negKeyword" id="negKeyword"
              [ngModel]="searchFilter.negKeyword" (ngModelChange)="changeFilter('negKeyword', $event)">
            </li>
          </ul>
        </div>

        <div class="filter_right">
          <label for="sort">{{'searchpage.sortOrder' | translate}}</label>
          <select id="sort" name="sort" [value]="sort" (change)="sortOrder($event.target.value, 'desc')">
            <option value="relevance">{{'searchpage.relevance' | translate}}</option>
            <option value="viewCount">{{'searchpage.viewCount' | translate}}</option>
            <option value="updateDate">{{'searchpage.updateDate' | translate}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</section>

<div id="resultList" tabindex="-1" #searchResultRef>
  <ng-content></ng-content>

  <ng-container *ngIf="searchResult && searchResult.length">
    <div *ngIf="correlation && correlation.length" class="correlation-wrapper">
      <label for="correlation" id="correlationLabel" (click)="correlationList.focus()">{{'searchpage.correlation' | translate}}</label> :
      <ul id="correlation" role="listbox" tabindex="-1" #correlationList>
        <ng-container *ngFor="let item of correlation">
          <a routerLink="./" [queryParams]="{keyword: item}" queryParamsHandling="merge" (click)="searchKeyword = item; onClickSearch($event)"><li>#{{item}}</li></a>
        </ng-container>
      </ul>
    </div>
    <ng-container *ngTemplateOutlet="pagingTmp; context: {
      $implicit: total,
      currentPage: currentPage,
      totalPages: totalPages,
      pageChange: pageChange
    }"></ng-container>
  </ng-container>
</div>

<!-- 分頁 -->
<ng-template #pagingTmp let-total let-currentPage="currentPage" let-totalPages="totalPages" let-pageChange="pageChange">
  <div class="row">
    <div class="col-sm-12 col-md-4 offset-md-4 col-lg-4 offset-lg-4">
      <div class="pages">
        <button class="btn btn-light bignext" [class.disabled]="currentPage === totalPages" [disabled]="currentPage === totalPages"
        attr.aria-disabled="{{currentPage === totalPages}}"
        (click)="pageChange(currentPage + 1)">{{'nextPage' | translate}}</button>
      </div>
    </div>

    <div class="col-sm-12 col-md-4 col-lg-4">
      <div class="pages">
        <ul class="custom-buttons">
          <li>
            <a href="javascript:void(0)" role="button" title="{{'prevPage' | translate}}" class="btn btn-link button" [class.disabled]="currentPage === 1"
            attr.aria-disabled="{{currentPage === 1}}"
            (click)="pageChange(currentPage - 1)">
              <i class="fa fa-angle-left" aria-hidden="true"></i>
              <span class="sr-only">{{'prevPage' | translate}}</span>
            </a>
          </li>
          <li><input class="numbers" type="number" title="{{'jumpPage' | translate}}" [disabled]="totalPages === 1"
            [value]="currentPage" min="1" [max]="totalPages"
            (change)="pageChange($event.target.value)"></li><span aria-hidden="true">/ {{totalPages | tmCurrency}} 頁</span>
          <li>
            <a href="javascript:void(0)" role="button" title="{{'nextPage' | translate}}" class="btn btn-link button" [class.disabled]="currentPage === totalPages"
            attr.aria-disabled="{{currentPage === totalPages}}"
            (click)="pageChange(currentPage + 1)">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
              <span class="sr-only">{{'nextPage' | translate}}</span>
            </a>
          </li>
          <li><p>{{'searchpage.searchResult' | translate}}<span class="snum">{{total | tmCurrency}}</span>{{'searchpage.numsData' | translate}}</p></li>
        </ul>
      </div>
    </div>
  </div>
</ng-template>